import type { RecipeFamily } from "../../domain/types";
import { curryRecipes } from "./curry";
import { grainBowlRecipes } from "./grainBowls";
import { pastaNoodleRecipes } from "./pastaNoodles";
import { saladRecipes } from "./salads";
import { sandwichWrapRecipes } from "./sandwichWraps";
import { soupRecipes } from "./soups";
import { stirFryRecipes } from "./stirFries";
import { trayBakeRecipes } from "./trayBakes";

export const recipeFamilies: RecipeFamily[] = [
  ...soupRecipes,
  ...saladRecipes,
  ...trayBakeRecipes,
  ...curryRecipes,
  ...stirFryRecipes,
  ...pastaNoodleRecipes,
  ...grainBowlRecipes,
  ...sandwichWrapRecipes,
];

export const recipeById = new Map(
  recipeFamilies.map((recipe) => [recipe.id, recipe]),
);
